module.exports = __webpack_public_path__ + "static/media/Lynet Owuor.d764c663.jpeg";